import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "-1 -1 26 26",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 23.25L12 0.75",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22.5 11.25L12 0.75 1.5 11.25",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2.5
	})]
});
export default SvgArrowUp;
